var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72915 4.16667L16.9297 19.0065M1.72915 4.16667C2.2947 3.521 3.13942 3.11111 4.08316 3.11111H9.22177M1.72915 4.16667C1.27429 4.68596 1 5.35777 1 6.0915V17.0196C1 18.6656 2.38038 20 4.08316 20H15.3881C17.0909 20 18.4713 18.6656 18.4713 17.0196V12.549M9.22177 12.549L2.54158 19.0065M16.5057 4.37778V4.31428M20 4.30435C20 6.50725 16.5057 9.44444 16.5057 9.44444C16.5057 9.44444 13.0115 6.50725 13.0115 4.30435C13.0115 2.47941 14.5759 1 16.5057 1C18.4356 1 20 2.47941 20 4.30435Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon-3.d9c33ae723568f349b919b0cd64a1d68.svg";
export { ForwardRef as ReactComponent };